<template>
    <div class="container-fluid mt-45">
        <div class="row">
            <div class="col d-flex flex-column flex-md-row justify-content-between">
                <div>
                    <h2>Dashboard</h2>
                </div>

                <div class="mt-4 mt-md-0">
                    <button v-show="myOrganisationSettings.fulfilmentOptions != null && myOrganisationSettings.fulfilmentOptions != FulfilmentOptions.POST" @click="verifyDevice()" class="btn btn-primary btn-lg btn-assign-test btn-block-mobile lg-shadow mr-2">Query a Device</button>
                    <button v-show="!facilitiesAllDisabled" @click="assignATestKit()" class="btn btn-success btn-lg btn-assign-test btn-block-mobile lg-shadow">Assign a Test Kit</button>
                </div>
            </div>
        </div>

        <Searchbar />

        <TestResults v-on:loadingFinished="loading = !loading" />
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Searchbar from '@/components/SearchbarComponent.vue'
import TestResults from '@/components/TestResultsListComponent.vue'
import HCPMustCompleteTrainingModal from '@/components/modals/HCPMustCompleteTrainingModalComponent.vue'
import VerifyDeviceModal from '@/components/modals/VerifyDeviceModalComponent.vue'
import SignalRMixin from '@/mixins/SignalRMixin'
import FulfilmentOptions from '../../../Common/enums/FulfilmentOptionsType'
export default {
    name: 'Dashboard',

    mixins: [
        SignalRMixin
    ],

    components: {
        Searchbar,
        TestResults
    },

    data() {
        return {
            loading: true,
            VerifyDeviceModal,
            FulfilmentOptions
        }
    },

    computed: {
        ...mapGetters({
            facilitiesAllDisabled: 'FacilityStore/GetAllFacilitiesDisabled',
            trainingUpToDate: 'UserStore/GetTrainingUpToDate',
            myOrganisationSettings: 'OrganisationStore/GetMyOrganisationSettings'
        })
    },

    async mounted() {
        if (this.trainingUpToDate != null && !this.trainingUpToDate) {
            this.$modal.show(HCPMustCompleteTrainingModal, {}, { width: '410px' }, { 'before-close': this.closingHCPModal })
        }
    },

    methods: {
        ...mapActions({
            clearTestStore: 'TestStore/ClearData',
            clearConnectionInSignalRStore: 'SignalRStore/ClearConnection'
        }),

        assignATestKit() {
            this.clearTestStore()

            return this.$router.push({name: 'CreateOrSelectPatient'})
        },

        selectPatient() {
            this.clearTestStore()

            return this.$router.push({name: 'SelectAPatient'})
        },

        createPatient() {
            this.clearTestStore()

            return this.$router.push({name: 'CreatePatient'})
        },

        verifyDevice() {
            this.$modal.show(VerifyDeviceModal, {}, { width: '750px' }, { 'before-close': this.closingVerifyDeviceModal })
        },

        closingHCPModal(e) {
            e.cancel()
        },

        async closingVerifyDeviceModal(e) {        
            var stopConnection = true
            if(typeof e.params === 'object' && Object.keys(e.params).length && e.params.closeConnection != null && e.params.closeConnection != 'undefined' && !e.params.closeConnection) {
                stopConnection = false
            }
            if(stopConnection) {
                this.closeSignalRConnection()
            }
        }
    }
}
</script>